<!--
 * @Author: Gaho
 * @Date: 2024-03-14 16:10:43
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-20 18:17:55
 * @Description: 
-->
<template>
    <div
        v-if="gameHistory?.response?.length && Object.keys(odds).length && riskOptions.length"
        :class="
            gameHistory.response && gameHistory.response.length >= 10
                ? 'plinko-record plinko-record-gradient'
                : 'plinko-record'
        "
    >
        <div
            class="plinko-record-item"
            v-for="(item, index) in gameHistory.response.slice(0, 12)"
            v-show="index < 9"
            :key="item.randomSeed"
            :style="{
                background: getColor(item),
            }"
        >
            {{ item.coef }}x
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useGameHistoryStore } from '@/stores/cansino/gameHistory';
import { useJoinStateStore } from '@/stores/cansino/joinState';
export default defineComponent({
    name: 'plinkoResultHistory',
    props: {
        odds: {
            type: Object,
            default: () => ({})
        },
        riskOptions: {
            type: Array<'Low' | 'Medium' | 'High'>,
            default: () => ([])
        }
    },
    computed: {
        gameHistory(){
            const { gameHistoryDelay } = useGameHistoryStore();
            // 路由切换到别的游戏后，还会触发computed-gameHistory，防止这种问题出现
            if (useJoinStateStore().gameOfRoute !== 'plinkoGame'){
                return;
            }
            return gameHistoryDelay;
        }
    },
    methods: {
        getColor(item={}){
            const odds = this.odds;
            const riskOptions = this.riskOptions;
            const {sector, rows, coef} = item as any;
            if (!riskOptions[sector] || !rows){
                console.log('数据缺失, gameId =', deepCopy(item));
                return '';
            }
            try{
                // try 内部是将旧代码复制到此 
                return odds[riskOptions[sector]][rows]?.find(
                    (ele) => ele.mutil === coef,
                )?.color;
            }catch(err){
                return '';
            }
        },
    },
});
</script>

<style lang="scss" scoped>
.plinko-record {
    position: absolute;
    right: 9.5%;
    top: 3%;
    width: 31px;
    z-index: 1;

    .plinko-record-item {
        align-items: center;
        border-radius: 2px;
        box-shadow: inset 0 1px #ffffff7a;
        display: flex;
        font-size: 11px;
        font-weight: 600;
        height: 20px;
        justify-content: center;
        letter-spacing: -0.07em;
        line-height: 12px;
        margin-bottom: 4px;
        text-shadow: 0 1px 2px #dc6108;
        width: 100%;
        user-select: none;
        will-change: top, bottom;
    }

    @media (max-width: 460px) {
        .plinko-record-item {
            font-size: 8px;
            height: 18px;
        }
    }
}

.plinko-record-gradient {
    &::after {
        background: linear-gradient(180deg, rgba(24, 24, 47, 0) 10%, #18182f 90.73%);
        bottom: 0;
        content: '';
        display: block;
        height: 120px;
        left: 0;
        position: absolute;
        width: 100%;
    }
}

@media (max-width: 460px) {
    .plinko-record {
        right: 5.5%;
        top: 18%;
        width: 23px;
    }
}
</style>